export const formatDate = (dateStr) => {
  if (!dateStr) return "—";
  return new Date(dateStr).toLocaleDateString("he-IL");
};

export const formatNum = (n) =>
  n != null && n !== 0 ? Number(n).toFixed(2) : n === 0 ? "0" : "—";
